var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopCatBySentiment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "125px",
    viewBox: "0 0 235 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F30C24A1-C958-49EF-915A-62E7E101B35B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 235,
    height: 125,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat-Simplified-Widget---Style-Guide",
    transform: "translate(-729.000000, -479.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EEEEEE",
    x: 0,
    y: 0,
    width: 1463,
    height: 2535
  }), /*#__PURE__*/React.createElement("g", {
    id: "Widget/Data/Chat/Summary-Metrics-Copy-3",
    transform: "translate(729.000000, 479.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 235,
    height: 125
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#6BBE0B",
    x: 183,
    y: 91,
    width: 24,
    height: 17
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(175.000000, 44.000000)",
    fill: "#6BBE0B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.517,22.1892667 C22.9255,22.1026 22.373,22.5056 22.282,23.0949333 C22.0675,24.4837667 20.8975,25.4891 19.5,25.4891 C18.1025,25.4891 16.9325,24.4837667 16.718,23.0949333 C16.627,22.5056 16.068,22.1026 15.483,22.1892667 C14.8915,22.2802667 14.4863333,22.8349333 14.5773333,23.4242667 C14.9565,25.8769333 17.0256667,27.6557667 19.5,27.6557667 C21.9743333,27.6557667 24.0435,25.8769333 24.4226667,23.4242667 C24.5136667,22.8349333 24.1085,22.2802667 23.517,22.1892667",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333333,13 C9.63733333,13 8.66666667,13.9706667 8.66666667,15.1666667 C8.66666667,16.3626667 9.63733333,15.1666667 10.8333333,15.1666667 C12.0293333,15.1666667 13,16.3626667 13,15.1666667 C13,13.9706667 12.0293333,13 10.8333333,13",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1666667,13 C26.9706667,13 26,13.9706667 26,15.1666667 C26,16.3626667 26.9706667,15.1666667 28.1666667,15.1666667 C29.3626667,15.1666667 30.3333333,16.3626667 30.3333333,15.1666667 C30.3333333,13.9706667 29.3626667,13 28.1666667,13",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,36.8333333 C9.94283333,36.8333333 2.16666667,29.0571667 2.16666667,19.5 C2.16666667,9.94283333 9.94283333,2.16666667 19.5,2.16666667 C29.0571667,2.16666667 36.8333333,9.94283333 36.8333333,19.5 C36.8333333,29.0571667 29.0571667,36.8333333 19.5,36.8333333 M19.5,0 C8.7295,0 0,8.7295 0,19.5 C0,30.2705 8.7295,39 19.5,39 C30.2705,39 39,30.2705 39,19.5 C39,8.7295 30.2705,0 19.5,0",
    id: "Fill-7"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#999999",
    x: 7,
    y: 11,
    width: 156,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#999999",
    x: 7,
    y: 62,
    width: 119,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#999999",
    x: 7,
    y: 78,
    width: 102,
    height: 9
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopCatBySentiment);
export default __webpack_public_path__ + "static/media/top-cat-by-sentiment.173808e5198cef47a7af240d1e4c0685.svg";
export { ForwardRef as ReactComponent };